import Left from "@repo/icons/default/Left";
import { graphql } from "@repo/graphql-types";
import { createFileRoute, useParams } from "@tanstack/react-router";
import { AsyncDataWrapper } from "@/components/ui/async-data-wrapper";
import {
  HeaderButton,
  HeaderRoot,
  HeaderTitle,
} from "@/components/ui/layout/header/header";
import { Page } from "@/components/ui/layout/page/page";
import { useGraphQL } from "@/hooks/use-graphql";

import type { JSX } from "react";

const NotificationCenterIdPageQuery = graphql(`
  query NotificationCenterIdPage($id: Int!) {
    tbNotificacoesEnviadasApp_by_pk(codNotificacaoEnviadaApp: $id) {
      notificacoesInAppEnviadas {
        conteudoSanitizado
      }
    }
  }
`);

const NotificationCenterIdPage = (): JSX.Element => {
  const { id } = useParams({ from: "/home/notification-center/$id/" });
  const queryResult = useGraphQL(NotificationCenterIdPageQuery, { id: parseInt(id, 10) });

  const { data } = queryResult;

  return (
    <>
      <HeaderRoot>
        <HeaderButton icon={Left} align="start" />
        <HeaderTitle title="Notificação" />
      </HeaderRoot>
      <Page>
        <AsyncDataWrapper {...queryResult}>
          <div
            // biome-ignore lint/security/noDangerouslySetInnerHtml: conteúdo já sanitizado no backend (campo conteudoSanitizado)
            dangerouslySetInnerHTML={{
              __html:
                data?.tbNotificacoesEnviadasApp_by_pk?.notificacoesInAppEnviadas[0]
                  ?.conteudoSanitizado ?? "",
            }}
          />
          <div />
        </AsyncDataWrapper>
      </Page>
    </>
  );
};

export const Route = createFileRoute("/home/notification-center/$id/")({
  component: NotificationCenterIdPage,
});
